import Vue from 'vue';

const validationRules = {
    'required': function (value) {
        if (typeof value === 'boolean') {
            return value === false;
        }
        return !value || value.trim() === '' || value === 'undefined';
    },
    'url': function (value) {
        if (typeof value === 'boolean') {
            return value === false;
        }
        return !value || value.trim() === '' || value === 'undefined';
    },
    'password': function (value) {
        return value && value.length < 8;
    },
    'email': function (value) {
        return /^[\w\-\.\+]+@([\w\-]+\.)+[\w-]{2,4}$/.test(value) === false;;
    },
    'website': function (value) {
        return /^(https?\:\/\/)?(www\.)?[\w\-\_]+\.[\w]{2,}\/?.*$/.test(value) === false;
    },
    'min': function (value, ruleValue) {
        return parseInt(value) < parseInt(ruleValue);
    },
    'max': function (value, ruleValue) {
        return parseInt(value) > parseInt(ruleValue);
    }
};

var rulesEngine = function (rules, value) {
    var invalidRules = [];
    // check if optional field
    if ((!value || typeof value === "string" && value.trim() === '') && rules && rules.indexOf('required') === -1) {
        return []
    }

    if (rules) {
        rules.split('|').forEach(function (rule) {
            // ex: min:7 -> rule[0] -> min, rule[1]-> 7

            if(rule.indexOf(':')>-1){
                let ruleParts = rule.split(":");
                validationRules[ruleParts[0]](value, ruleParts[1]) ? invalidRules.push(rule) : null;
            }
            else {
                validationRules[rule](value) ? invalidRules.push(rule) : null;
            }
        });
    }
    return invalidRules;
};

export function FormValidation(formId) {

    var self = this, $formRef;

    let hideElementErrors = function (el, errors) {
        $(el).removeClass('is-danger');
        let $parent = $(el).parents('.field');
        $parent.find('[rule]').hide();
    };

    let showElementErrors = function (el, errors) {
        $(el).addClass('is-danger');
        let $parent = $(el).parents('.field');
        errors.forEach((error) => {
            $parent.find(`[rule="${error}"]`).show();
        });
    };

    self.runAllValidations = function (noScroll) {
        let isValid = true, scrolled=false;

        $formRef.find('[vrules]').each(function (index) {

            let el = this;
            let inputValidity = self.runSingleValidation(el);
            inputValidity.hideErrors();
            if (!inputValidity.isValid) {
                // cflog(inputValidity,'inputValidity', el)
                inputValidity.showErrors();
                isValid = false;
                if( !scrolled && !noScroll){
                    let $el = $(el);
                    $([document.documentElement, document.body]).animate({
                        scrollTop: ($el.attr('type') === 'hidden'? $(el).parent().offset().top: $(el).offset().top)- 50
                    }, 200);
                    scrolled=true;
                }
            }



        });
        return isValid;
    };

    self.isFormValid = function(){
        let isValid = true;
        $formRef.find('[vrules]').each(function () {
            let inputValidity = self.runSingleValidation(this);
            if (!inputValidity.isValid) {
                isValid = false;
            }
        });
        return isValid;
    };

    self.focusOnFirstInvalidElement = function(){
        for( let el of $formRef.find('[vrules]')){
            let inputValidity = self.runSingleValidation(el);
            if (!inputValidity.isValid) {
               setTimeout(()=>{
                   $(el).focus();
               },100);
               break;
            }
        }
    }

    self.runSingleValidation = function (el) {
        let value;
        let $this=$(el);
        let rules = $this.attr('vrules');

        if (el.nodeName.toLowerCase() === 'select') {
            value = $this.find('option:selected').val();
        }
        else if (el.nodeName.toLowerCase() === 'div' && $this.attr('vtarget')) {
            value = $this.find( $this.attr('vtarget')).val();
        } else if (el.nodeName.toLowerCase() === 'div' && el.className.indexOf('radio-group') > -1) {
            value = $this.find('input:checked').val();
        }  else if (el.nodeName.toLowerCase() === 'input' && $this.attr('type') === 'checkbox' ) {
            value = $this.prop('checked');
        } else {
            value = $this.val().trim();
        }
        let invalidRules = rulesEngine(rules, value);

        return {
            isValid: invalidRules.length === 0,
            errors: invalidRules,
            showErrors: function(){
                showElementErrors(el, invalidRules);
            },
            hideErrors: function(){
                hideElementErrors(el, invalidRules);
            }
        };
    };


    (function () {
        $formRef = typeof formId === 'object'? formId: $(formId);

        $(formId).on('blur', 'input, textarea, select', function () {
            let v = self.runSingleValidation(this);
            v.hideErrors();
            if(!v.isValid){
                v.showErrors();
            }
        });
        $(formId).on('click', '.radio-group', function () {
            let v = self.runSingleValidation(this);
            v.hideErrors();
            if(!v.isValid){
                v.showErrors();
            }
        });
    })();
}

export class Form {


    static runAllValidations(id) {
        let isValid = true;

        $(id).find('[vrules]').each(function () {
            let inputValidity = Form.runSingleValidation(this);
            if (!inputValidity) {
                isValid = false;
            }
        });
        return isValid;
    }

    static runSingleValidation(el) {

        let $this = $(el), value;
        let $parent = $this.parents('.form-group, .v-form-group');
        let rules = $this.attr('vrules');

        if (el.nodeName.toLowerCase() === 'select') {
            value = $this.find('option:selected').val();
        } else if (el.nodeName.toLowerCase() === 'div' && el.className.indexOf('radio-group') > -1) {
            value = $this.find('input:checked').val();
        } else {
            value = $this.val().trim();
        }

        let invalidRules = rulesEngine(rules, value);
        $parent.find('[rule]').hide();
        invalidRules.forEach((invalidRule) => {
            $parent.find(`[rule="${invalidRule}"]`).show();
        });

        return invalidRules.length === 0;
    };
}


// Register a global custom directive called `v-form-validation`
Vue.directive('formValidation', {
    // When the bound element is inserted into the DOM...
    inserted: function (el) {

    },
    bind: function (el, binding) {
        let $el = $(el);
        var formValidation = new FormValidation(el);
        $el.on('blur', 'input, textarea, select', function () {
            let v = formValidation.runSingleValidation(this);
            v.hideErrors();
            if(!v.isValid){
                v.showErrors();
            }
        });
        $el.on('click', '.radio-group', function () {
            let v = formValidation.runSingleValidation(this);
            v.hideErrors();
            if(!v.isValid){
                v.showErrors();
            }
        });

    },
});
